import React from 'react';
import { observer } from 'mobx-react';

// Translation
import translate from '../translate/Translate';

// Helpers
import { getLocalData, storeLocalData } from '../../helpers';

// Components
import Dropdown from '../common/Dropdown';

// Icons
import * as icons from '../ui/Icons';

const Accessibility = observer(
  class Accessibility extends React.Component {
    componentDidMount() {
      const { AppStore } = this.props.store;
      const { defaultFontSize } = AppStore;
      const fontSize = getLocalData('accessibility_fontSize');
      const highContrast = getLocalData('accessibility_highContrast');
      const openDyslexia = getLocalData('accessibility_openDyslexia');

      // Check for store accessibility preferences
      if (fontSize && fontSize !== defaultFontSize) {
        AppStore.fontSize = parseInt(fontSize, 10);
      }

      if (highContrast && highContrast === 'true') {
        AppStore.highContrast = true;
      } else {
        AppStore.highContrast = false;
      }

      if (openDyslexia && openDyslexia === 'true') {
        AppStore.dyslexic = true;
      } else {
        AppStore.dyslexic = false;
      }
    }

    /**
     * adjustFontSize
     * @param {integer} amount
     */
    adjustFontSize = amount => {
      const { AppStore } = this.props.store;
      const { defaultFontSize } = AppStore;

      if (amount) {
        if (
          (amount > 0 && AppStore.fontSize < 34) ||
          (amount < 0 && AppStore.fontSize > 10)
        ) {
          AppStore.fontSize += amount;
        }
      } else {
        AppStore.fontSize = defaultFontSize;
      }

      storeLocalData('accessibility_fontSize', AppStore.fontSize);
    };

    handleStylesheet = (id, render) => {
      const stylesheet = document.querySelector(`#${id}`);

      if (render) {
        stylesheet.rel = 'stylesheet';
      } else {
        stylesheet.rel = 'stylesheet alternate';
      }

      // Move stylesheet to the bottom of the head to ensure it takes precedence
      stylesheet.remove();
      document.head.append(stylesheet);
    };

    render() {
      const { store, translation } = this.props;
      const { AppStore } = store;
      const { defaultFontSize, dyslexic, fontSize, highContrast } = store.AppStore;

      const options = [
        {
          title: highContrast
            ? translation.options.high_contrast_disable
            : translation.options.high_contrast_enable,
          action: () => {
            AppStore.highContrast = !AppStore.highContrast;
            storeLocalData('accessibility_highContrast', AppStore.highContrast);
          },
          icon: <icons.contrast />
        },
        {
          title: translation.options.increase_size,
          action: () => this.adjustFontSize(2),
          icon: <icons.textSizeUp />
        },
        {
          title: translation.options.decrease_size,
          action: () => this.adjustFontSize(-2),
          icon: <icons.textSizeDown />
        },
        {
          title: translation.options.reset_size,
          action: () => this.adjustFontSize(),
          icon: <icons.textSizeReset />
        },
        {
          title: dyslexic
            ? translation.options.dyslexia_font_disable
            : translation.options.dyslexia_font_enable,
          action: () => {
            AppStore.dyslexic = !AppStore.dyslexic;
            storeLocalData('accessibility_openDyslexia', AppStore.dyslexic);
          },
          icon: <icons.dyslexic />
        }
      ];

      // Adjust document font size
      if (fontSize !== defaultFontSize) {
        document.documentElement.style = `font-size: ${fontSize}px`;
      } else {
        document.documentElement.style = null;
      }

      // Toggle stylesheets
      this.handleStylesheet('open-dyslexic', AppStore.dyslexic);
      this.handleStylesheet('high-contrast', AppStore.highContrast);

      return (
        <div>
          {/* <React.Suspense fallback={<></>}>
          {AppStore.dyslexic && <OpenDyslexic />}
        </React.Suspense> */}

          <Dropdown
            {...this.props}
            className="icon--sm"
            icon={<icons.accessibility />}
            id="accessibility-options"
            options={options}
            triggerText={translation.label}
            triggerClassName="dropdown__trigger--invisible"
          />
        </div>
      );
    }
  }
);

export default translate('Accessibility')(Accessibility);
